
































import Api from "./Api";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import CompanyUserRequired from "../../CompanyRequired";
import rd from "@/modules/vRoutedefs";
import {PersonMissingPhoneReportRow} from "@/modules/reportmodels";
import {DateTime} from "@/modules/models";
import PersonMarker from "@/components/PersonMarker.vue";
import DatePicker from "@/components/DatePicker.vue";

@Component({
  components: {
    "at-personmarker": PersonMarker,
    "at-date-picker": DatePicker,
  }
})
export default class UsersWithoutPhoneReport extends CompanyUserRequired {
  @Inject()
  api!: Api;

  @Prop({default: () => DateTime.now().dayOffset(-7).toMidnight()})
  from!: DateTime;
  @Prop({default: () => DateTime.now().nextDay().toMidnight()})
  to!: DateTime;

  get fromParam() {
    return this.from;
  }
  set fromParam(v: DateTime) {
    if(!v.equals(this.from)) {
      this.$router.push({ path: rd.users.reports.withoutPhone.path, query: {"from": v.toDayParam(), "to": this.to.toDayParam()} });
    }
  }
  get toParam() {
    return this.to;
  }
  set toParam(v: DateTime) {
    if(!v.equals(this.to)) {
      this.$router.push({ path: rd.users.reports.withoutPhone.path, query: {"from": v.toDayParam(), "to": this.to.toDayParam()} });
    }
  }


  loading = false;

  headers = [
    {"text": "", value: "", sortable: false},
    {"text": "Fornavn", value: "firstName", align: "left"},
    {"text": "Etternavn", value: "lastName", align: "left"},
    {"text": "Firma", value: "company", align: "left"},
    {"text": "Sist innregistrert", value: "lastTimeIn", align: "left"},
    {"text": "Siste anlegg", value: "terminalLocation", align: "left"},
  ];

  items: PersonMissingPhoneReportRow[] = [];

  @Watch("from")
  @Watch("to")
  async loadResult() {
    this.loading = true;
    try {
      this.items = await this.api.fetchPersonsMissingPhone(this.company.orgNum, this.from, this.to);
    } catch (err) {
      this.emitError(err);
    } finally {
      this.loading = false;
    }
  }

  userTo(personGuid: string) {
    return {name: rd.users.name, query: {guid: personGuid}};
  }
  locationTo(locid: number) {
    return {name: rd.locations.location.name, params: {locationId: locid}};
  }

  created() {
    this.loadResult();
  }
}
